<div class="map-navigation-tools" [ngClass]="{ 'right-sidebar-open': rightSidebarVisible() }">
    <div class="map-button position" (click)="centerMapOnLocation()"></div>
    <div class="map-button transparent top-margin zoom-to-estate" (click)="centerMapOnEstateLocation()"></div>
    <div class="map-button top-margin zoom-in" (click)="zoomIn()"></div>
    <div class="map-button zoom-out" (click)="zoomOut()"></div>
    <map-navigation-settings></map-navigation-settings>
</div>
